







































import { Component, Prop, Vue } from 'vue-property-decorator';
import ChangedDocumentStatusDocumentReceivedViewModel
  from '@/vue-app/view-models/allianz-dashboard/allianz-actions/changed-document-status/changed-document-status-document-received-view-model';

@Component({ name: 'ChangedDocumentStatusDocumentReceived' })
export default class ChangedDocumentStatusDocumentReceived extends Vue {
  @Prop(String)
  document_type!: string;

  document_received_view_model = Vue.observable(
    new ChangedDocumentStatusDocumentReceivedViewModel(),
  );

  mounted() {
    this.document_received_view_model.initialize(this.document_type);
  }

  closeModal() {
    this.$emit('closeDialog');
  }
}
